<template>
  <div class="field">
    <label class="label">{{label}}<b-icon pack="fas" icon="star" class="fa-ss" v-show="required"></b-icon></label>
    <div class="control is-fullwidth">
        <multiselect @select="$markDirty()"
        :name="instanceName"
        data-vv-validate-on="input|close"
        :data-vv-as="this.validateAs"
        v-validate="{'required': required}"
        :class="{'is-danger': errors.has(instanceName) }"
        v-model="selectedMake"
        :options="availableMakes"
        placeholder="Type to search for a registered vehicle make"
        label="name"
        trackBy="id"
        :disabled="isDisabled"
        :hideSelected="true"></multiselect>
    </div>
    <span v-show="errors.has(instanceName)" class="help is-danger"><i v-show="errors.has(instanceName)" class="fas fa-exclamation-triangle"></i> {{ errors.first(instanceName) }}</span>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex'
const mapVehicleMakeGetters = createNamespacedHelpers('vehicleMake').mapGetters

export default {
  inject: {
    $validator: '$validator'
  },
  name: 'MakeSelector',
  props: {
    value: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: 'Item'
    },
    validateAs: {
      type: String,
      default: 'Item'
    },
    selectedDealer: {
      type: Object,
      default: null
    },
    filter: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedMake: this.value,
      data: [],
      instanceName: 'make-component-' + this.$uuid.v4()
    }
  },
  computed: {
    ...mapVehicleMakeGetters(['allVehicleMakes']),
    availableMakes: function () {
      return this.allVehicleMakes
    }
  },
  watch: {
    selectedMake: function (newValue, oldValue) {
      this.$emit('input', newValue)
    },
    currentMake: function (newValue, oldValue) {
      this.selectedMake = newValue
    },
    value: function (newValue, oldValue) {
      this.selectedMake = newValue
    }
  }
}

</script>
